import React from 'react';
import classNames from 'classnames';
import { useFeature } from '@growthbook/growthbook-react';
import MainNavigation from './MainNavigation/MainNavigation';
import ProvidersNavigation from './ProvidersNavigation/ProvidersNavigation';
import CategoriesNavigation from './CategoriesNavigation/CategoriesNavigation';
import RenderPixel from '../../AppSCCOM/components/RenderPixel';
import { useIsDesktopLayout } from '../../hooks/useIsDesktopLayout';
import { useCommonConfiguration } from '../../hooks/useCommonConfiguration';
import { useIsSSCOMBrand } from '../../hooks/useIsSSCOMBrand';
import { FEATURES } from '../../constants/featureToggling';

import styles from './Navigation.module.css';

const Navigation = ({ className }) => {
  const commonConfig = useCommonConfiguration();
  const isDesktop = useIsDesktopLayout();
  const isSCCOM = useIsSSCOMBrand();
  const isStickySideMenu = useFeature(FEATURES.ENABLED_STICKY_SIDE_MENU).on;

  let sectionIndex = 0;
  const getSectionIndex = () => sectionIndex++;

  return (
    <nav
      role="navigation"
      className={classNames(className, {
        [styles.sticky_ig]: isStickySideMenu,
      })}
    >
      <MainNavigation
        sectionIndex={getSectionIndex()}
        className={styles.section_ig}
      />
      <CategoriesNavigation
        limit={commonConfig?.sidebarMenuItemLimits?.categories}
        sectionIndex={getSectionIndex()}
        className={styles.section_ig}
      />
      <ProvidersNavigation
        limit={commonConfig?.sidebarMenuItemLimits?.providers}
        sectionIndex={getSectionIndex()}
        className={styles.section_ig}
      />
      {isSCCOM && isDesktop && <RenderPixel selectorId="side-menu" />}
    </nav>
  );
};

export default Navigation;
